/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import "./src/styles/global.css"
import "bootstrap/dist/css/bootstrap.min.css"
import React from 'react'
import { LanguageProvider } from './src/context/LanguageContext'

// Remove no-js class on client-side
export const onInitialClientRender = () => {
  if (typeof window !== 'undefined') {
    document.body.classList.remove('no-js');
  }
};

// Handle client-side navigation
export const shouldUpdateScroll = () => {
  return false;
};

export const wrapRootElement = ({ element }) => {
  return (
    <LanguageProvider>
      {element}
    </LanguageProvider>
  )
}
